export default __webpack_public_path__ + "static/media/hanna_yen.d142ebce.jpg";